export function assertNonNullish<T>(maybeNullish: T | undefined | null, message?: string): asserts maybeNullish is T {
  if (maybeNullish === null || maybeNullish === undefined) {
    throw new Error(message ?? 'Whoa! Unexpected nullish');
  }
}
export function nullishThrows<T>(maybeNullish: T | undefined | null, message?: string): T {
  assertNonNullish(maybeNullish, message);
  return maybeNullish;
}